<script>
const sidebarMenu = [
    
    // {
    //     icon : 'fa fa-car-side' , title : 'PDC Stock' , path : '/pdc-stock'
    // },
    // {
    //     icon : 'fa fa-car-side' , title : 'Dealer Report' , path : '/dealer'
    // },
    // {
    //     icon : 'fa fa-cubes' , title : 'Data' , path : '/data' ,
    //     children : [
    //         {
    //             path : '/data/vehicle' , title : "Vehicle",
    //         },
    //         {
    //             path : '/data/customer' , title : "Customer",
    //         },
    //         {
    //             path : '/data/qrcode' , title : "QR Code",
    //         }
    //     ]
    // },
    {
        icon : 'li' , title : 'Reports'
    },
    // {
    //     icon : 'fa fa-chart-bar' , title : 'National Report' , path : '/national-report'
    // },
    {
        icon : 'fas fa-lightbulb' , title : 'Highlights' , path : '/highlights'
    },
    // {
    //     icon : 'fas fa-chart-bar' , title : 'Dealer Service' , path : '/dealer-service'
    // },
    // {
    //     icon : 'fas fa-table' , title : 'Dealer Registration and Service' , path : '/dealer-registration-and-service'
    // },
    {
        icon : 'fas fa-warehouse' , title : 'Incoming PDC' , path : '/vehicle/incoming-pdc'
    },
    // {
    //     icon : 'fas fa-clock' , title : 'Aging Report' , path : '/vehicle/aging'
    // },
    // {
    //     icon : 'fas fa-truck' , title : 'Lead Time' , path : '/vehicle/leadtime'
    // },
    {
        icon : 'fa fa-car-side' , title : 'Mapping Report' , path : '/mapping/report'
    },
    {
        icon : 'fas fa-search' , title : 'Vehicle Detail' , path : '/vehicle/detail'
    },
    // {
    //     icon : 'fas fa-exclamation-circle' , title : 'Unmatch Report' , path : '/unmatch'
    // },
    // {
    //     icon : 'fas fa-qrcode' , title : 'Replaced QR Code' , path : '/replace-qr'
    // },
    
    // {
    //     icon : 'fas fa-search' , title : 'Vehicle Search' , path : '/vehicle/search'
    // },
    {
        icon : 'fas fa-users-cog' , title : 'User Management' , path : '/user'
    },
    // {
    //     icon : 'fa fa-file-alt' , title : 'Log Report' , path : '/log/report'
    // },
    {
        icon : 'fa fa-bullseye' , title : 'Product Plan' , path : '/product-plan'
    }

]




export default sidebarMenu;
</script>
